export default __webpack_public_path__ + "static/media/growth.045a832d.png";